<template>
    <div class="container">
        <div class="content">
            <el-tabs v-model="activeName" class="custom-tabs2" style="padding-top: 29px;">
                <el-tab-pane :label="item.label" :name="item.name" v-for="(item, index) in tags" :key="index"></el-tab-pane>
            </el-tabs>
            <div v-if="activeName == 1" class="main"  >
                <emplpyment-detail  :detail="detail"  :pageActive="pageActive" :footer="footer"/>
                
                <!-- <div style="height: 60px;"></div> -->
                <div v-if="false">
                    <div class="title">主要信息</div>
                    <div class="content-h">
                        <div class="content-h-l">
                            <div class="content-h-l-img">
                                <img v-if="detail.image" :src="detail.image" style="width: 84px;height: 84px;border-radius: 4px 4px 4px 4px;" />
                                <img v-if="!detail.image" src="../../assets/def_avatar_84px.png" style="width: 84px;height: 84px;border-radius: 4px 4px 4px 4px;" />
                            </div>
                            <div class="content-h-l-c">
                                <div style="display:flex;">
                                    <div class="name">{{ detail.reallyName || '--' }}</div>
                                    <div class="sex-m" v-if="detail.sex == '1'"><img src="../../assets/icon_nan.png"
                                            style="width: 24px;height: 24px;" />
                                    </div>
                                    <div class="sex-w" v-if="detail.sex == '2'"><img src="../../assets/icon_women.png"
                                            style="width: 24px;height: 24px;" /></div>
                                    <div class="status" v-if="detail.statusLabel == '已转正'">{{ detail.statusLabel }}</div>
                                    <div class="status1" v-if="detail.statusLabel == '待离职'">{{ detail.statusLabel }}</div>
                                    <div class="status2" v-if="detail.statusLabel == '试用'">{{ detail.statusLabel }}</div>
                                </div>
                                <div style="display:flex;margin-top:20px">
                                    <div class="text">员工工号：{{ detail.serial || '--' }}</div>
                                    <div class="text">职位：{{ detail.positionName || '--' }}</div>
                                    <div class="text">所属部门：{{ detail.orgName || '--' }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="content-h-r">
                            <div class="time">创建日期：{{ detail.createdTime || '--' }}</div>
                        </div>
                    </div>
                    <div class="content-c">
                        <el-form :inline="true" :model="form" ref="form" class="l-form" size="small" label-width="84px">
                            <el-form-item label="入职日期：">
                                <div class="text-f">{{ detail.employeeDate || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="直属上级：">
                                <div class="text-f">{{ detail.directSuperior || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="聘用形式：" label-width="120px">
                                <div class="text-f">{{ detail.jobNatureLabel || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="工作手机号：" label-width="96px">
                                <div class="text-f">{{ detail.workPhone || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="登录手机号：" label-width="96px">
                                <div class="text-f">{{ detail.phoneNumber || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="手机号1：">
                                <div class="text-f">{{ detail.extraPhoneFirst || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="手机号2：">
                                <div class="text-f">{{ detail.extraPhoneSecond || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="钉钉登录手机号：" label-width="120px">
                                <div class="text-f">{{ detail.dingPhone || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="转正日期：" label-width="96px">
                                <div class="text-f">{{ detail.confirmationDate || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="离职日期：" label-width="96px">
                                <div class="text-f">{{ detail.leaveTime || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="更新日期：">
                                <div class="text-f">{{ detail.updatedTime || '--' }}</div>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="split-line"></div>
                    <div class="title">基础信息</div>
                    <div class="content-c">
                        <el-form :inline="true" :model="form" ref="form" class="l-form" size="small" label-width="98px">
                            <el-form-item label="招聘信息来源：" label-width="106px">
                                <!-- <template #label>
                                    <div
                                        style="line-height: 32px;width:106px;text-align:right;padding-right: 8px;box-sizing: border-box;">
                                        招聘信息来源：
                                    </div>
                                </template> -->
                                <div class="text-f">{{ detail.recruitOriginLabel || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="身份证号码：">
                                <div class="text-f">{{ detail.idCardNumber || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="出生日期：" label-width="120px">
                                <div class="text-f">{{ detail.dateOfBirth || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="属相：">
                                <div class="text-f">{{ detail.zodiacLabel || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="民族：">
                                <div class="text-f">{{ detail.nation || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="最高学历：" label-width="106px">
                                <div class="text-f">{{ detail.educationalLevelLabel || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="婚姻状况：">
                                <div class="text-f">{{ detail.maritalStatusLabel || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="汽(机)车驾照：" label-width="120px">
                                <div class="text-f">{{ detail.drivingLicenseLevelLabel || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="微信号：">
                                <div class="text-f">{{ detail.wechatNumber || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="邮箱地址：">
                                <div class="text-f">{{ detail.email || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="爱好/专长：" label-width="106px">
                                <div class="text-f">{{ detail.hobby || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="身高(cm)：">
                                <div class="text-f">{{ detail.height || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="体重(kg)：" label-width="120px">
                                <div class="text-f">{{ detail.weight || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="政治面貌：">
                                <div class="text-f">{{ detail.politicalAffiliationLabel || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="籍贯：">
                                <div class="text-f">{{ detail.nativePlace || '--' }}</div>
                            </el-form-item>
                            <el-form-item label="户口性质：" label-width="106px">
                                <div class="text-f">{{ detail.householdTypeLabel || '--' }}</div>
                            </el-form-item>
                            <!-- <el-form-item label="户口所在地：">
                                <div class="text-f">{{ detail.householdResidence || '--' }}</div>
                            </el-form-item> -->
                            <el-form-item label="身份证 详细地址：" label-width="120px">
                                <template #label>
                                    <div
                                        style="line-height: 16px;">
                                        身份证 <br>详细地址：
                                    </div>
                                </template>
                                <div class="text-f" style="line-height: 16px;">{{
                                    detail.householdResidenceDetail || '--' }}
                                </div>
                            </el-form-item>
                            <!-- <el-form-item label="现居住地：">
                                <div class="text-f">{{ detail.currentResidence || '--' }}</div>
                            </el-form-item> -->
                            <el-form-item label="居住地 详细地址：">
                                <template #label>
                                    <div
                                        style="line-height: 16px;">
                                        居住地 <br>详细地址：
                                    </div>
                                </template>
                                <div class="text-f" style="line-height: 16px;">{{ detail.currentResidenceDetail
                                    || '--' }}</div>
                            </el-form-item>
                            <div style="width: 100%;">
                                <el-form-item label="紧急联系人姓名：" label-width="106px">
                                    <template #label>
                                        <div style="line-height: 16px;">
                                            紧急联系人 <br>姓名：
                                        </div>
                                    </template>
                                    <div class="text-f">{{ detail.emergencyContactName || '--' }}</div>
                                </el-form-item>
                                <el-form-item label="紧急联系人电话：" label-width="106px">
                                    <template #label>
                                        <div style="line-height: 16px;">
                                            紧急联系人 <br>电话：
                                        </div>
                                    </template>
                                    <div class="text-f">{{ detail.emergencyContactPhone || '--' }}</div>
                                </el-form-item>
                            </div>
                            <el-form-item label="原单位是否存在纠纷：" label-width="106px"  style="width: 100%;">
                                <template #label>
                                    <div
                                        style="line-height: 16px;">
                                        <span>原单位是否</span><br><span>存在纠纷：</span>
                                    </div>
                                </template>
                                <!-- <div style="display:flex;">
                                    <div class="text-f" style="margin-right:20px" v-if="detail.disputeFlag == '0'">否</div>
                                    <div class="text-f" style="margin-right:20px" v-else>是</div>
                                    <div class="text-f" v-if="detail.disputeFlag == '1'">{{
                                        detail.dispute
                                        ||
                                        '--' }}</div>
                                </div> -->
                                <div class="text-f">
                                    <div v-if="detail.disputeFlag">
                                        {{ detail.disputeFlag == 1 ? '是' : '否' }}
                                    </div>
                                    <div v-else>--</div>
                                    <div style="max-width:1000px;line-height:1.2">{{ detail.dispute }}</div>
                                </div>

                            </el-form-item>
                        </el-form>
                        <div class="relative">

                            <div style="min-height:32px;">
                                <el-form :inline="true" :model="form" ref="form" class="l-form" size="small">
                                    <el-form-item label="是否有亲戚/朋友在公司：" prop="" label-width="174px"
                                        style="width:200px;margin-left:16px">{{ detail.kinFlag == 1 ? '是' : '否' || '--'
                                        }}</el-form-item>
                                </el-form>
                            </div>
                            <div style="min-height:32px;flex:1;margin-left:146px" v-if="detail.kinFlag == 1">
                                <el-form :inline="true" :model="form" ref="form" class="l-form" size="small">
                                    <el-form-item label="其姓名">
                                        {{ detail.kinName || '--' }}
                                    </el-form-item>
                                    <el-form-item label="关系">
                                        {{ detail.kinRelationship || '--' }}
                                    </el-form-item>
                                    <el-form-item label="部门">
                                        {{ detail.kinOrganization || '--' }}
                                    </el-form-item>
                                </el-form>
                            </div>

                        </div>
                    </div>
                    <div class="split-line"></div>
                    <div class="title">工作履历<span style="font-weight: 400;font-size: 16px;color: #616363;">（时间由近至远）</span>
                    </div>
                    <div class="content-c">
                        <div v-for="(item, index) in detail.workRecordList" :key="index">
                            <div style="display:flex;justify-content:flex-start;align-items:center">
                                <div class="sort-index">{{ index + 1 }}</div>
                                <div class="sort-title">工作履历</div>
                            </div>
                            <el-form :inline="true" :model="form" ref="form" class="l-form" size="small" label-width="96px"
                                style="margin-top:24px">
                                <el-form-item label="起始日期：">
                                    {{ item.startTime || '--' }}
                                </el-form-item>
                                <el-form-item label="结束日期：">
                                    {{ item.endTime || '--' }}
                                </el-form-item>
                                <el-form-item label="单位名称：">
                                    {{ item.company || '--' }}
                                </el-form-item>
                                <el-form-item label="任职部门：">
                                    {{ item.organization || '--' }}
                                </el-form-item>
                                <el-form-item label="担任职位：">
                                    {{ item.post || '--' }}
                                </el-form-item>
                                <el-form-item label="现离职原因：">
                                    {{ item.resignationReasonLabel || '--' }}
                                </el-form-item>
                                <el-form-item label="月薪：">
                                    {{ item.salary || '--' }}
                                </el-form-item>
                                <el-form-item label="证明人：">
                                    {{ item.certifier || '--' }}
                                </el-form-item>
                                <el-form-item label="联系电话：">
                                    {{ item.phone || '--' }}
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="split-line"></div>
                    <div class="title">教育经历<span style="font-weight: 400;font-size: 16px;color: #616363;">（学历由高至低）</span>
                    </div>
                    <div class="content-c">
                        <div v-for="(item, index) in detail.educationList" :key="index">
                            <div style="display:flex;justify-content:flex-start;align-items:center">
                                <div class="sort-index">{{ index + 1 }}</div>
                                <div class="sort-title">教育经历</div>
                            </div>
                            <el-form :inline="true" :model="form" ref="form" class="l-form1" size="small" label-width="96px"
                                style="margin-top:24px">
                                <el-form-item label="起始日期：">
                                    {{ item.startTime || '--' }}
                                </el-form-item>
                                <el-form-item label="结束日期：">
                                    {{ item.endTime || '--' }}
                                </el-form-item>
                                <el-form-item label="学校名称：">
                                    {{ item.institutionName || '--' }}
                                </el-form-item>
                                <el-form-item label="专业：">
                                    {{ item.major || '--' }}
                                </el-form-item>
                                <el-form-item label="学历：">
                                    {{ item.educationalLevelLabel || '--' }}
                                </el-form-item>
                                <el-form-item label="教育类型：">
                                    {{ item.educationalModeLabel || '--' }}
                                </el-form-item>

                            </el-form>
                        </div>
                    </div>
                    <div class="split-line"></div>
                    <div class="title">家庭信息
                    </div>
                    <div class="content-c">
                        <div v-for="(item, index) in detail.familyInfoList" :key="index">
                            <div style="display:flex;justify-content:flex-start;align-items:center">
                                <div class="sort-index">{{ index + 1 }}</div>
                                <div class="sort-title">家庭成员</div>
                            </div>
                            <el-form :inline="true" :model="form" ref="form" class="l-form1" size="small" label-width="96px"
                                style="margin-top:24px">
                                <el-form-item label="本人关系：">
                                    {{ item.familyRelationshipsLabel || '--' }}
                                </el-form-item>
                                <el-form-item label="姓名：">
                                    {{ item.name || '--' }}
                                </el-form-item>
                                <!-- <el-form-item label="出生日期：">
                                    {{ item.dateOfBirth || '--' }}
                                </el-form-item> -->
                                <el-form-item label="工作单位：">
                                    {{ item.company || '--' }}
                                </el-form-item>
                                <el-form-item label="职务：">
                                    {{ item.post || '--' }}
                                </el-form-item>
                                <el-form-item label="联系电话：">
                                    {{ item.phone || '--' }}
                                </el-form-item>
                                <!-- <el-form-item label="是否为紧急联系人：">
                                    <template #label>
                                        <div
                                            style="line-height: 16px;width:96px;text-align:right;padding-right: 8px;box-sizing: border-box;">
                                            是否为<br>紧急联系人：
                                        </div>
                                    </template>
                                    <div class="text-f">{{ item.emergencyFlag == 1 ? '是' : '否' || '--' }}</div>
                                </el-form-item> -->
                            </el-form>
                        </div>
                    </div>
                    <div class="split-line"></div>
                    <div class="title">培训经历<span style="font-weight: 400;font-size: 16px;color: #616363;">（非必填项）</span>
                    </div>
                    <div class="content-c">
                        <div v-for="(item, index) in detail.trainingInfoList" :key="index">
                            <div style="display:flex;justify-content:flex-start;align-items:center">
                                <div class="sort-index">{{ index + 1 }}</div>
                                <div class="sort-title">培训经历</div>
                            </div>
                            <el-form :inline="true" :model="form" ref="form" class="l-form1" size="small" label-width="96px"
                                style="margin-top:24px">
                                <el-form-item label="起始日期：">
                                    {{ item.startTime || '--' }}
                                </el-form-item>
                                <el-form-item label="结束日期：">
                                    {{ item.endTime || '--' }}
                                </el-form-item>
                                <el-form-item label="培训方式：">
                                    {{ item.trainingModeLabel || '--' }}
                                </el-form-item>
                                <el-form-item label="培训机构：">
                                    {{ item.institutionName || '--' }}
                                </el-form-item>
                                <div style="display: flex;">
                                    <el-form-item label="获取证书：">
                                        <div style="width: 100%;line-height: 16px;margin-top: 8px;" class="text-f">
                                            {{ item.certificate || '--' }}
                                        </div>

                                    </el-form-item>
                                    <div style="display: flex;">
                                        <el-form-item label="培训内容：">

                                        </el-form-item>
                                        <div style="width: 720px;line-height: 16px;margin-top: 8px;margin-left: -76px;"
                                            class="text-f">
                                            {{ item.trainingContent || '--' }}
                                        </div>
                                    </div>
                                </div>

                            </el-form>
                        </div>
                    </div>
                    <div class="split-line"></div>
                    <div style="height:68px"></div>
                </div>

            </div>
            <div v-if="activeName == 2">
                <assetInfo :detail="detail"></assetInfo>
            </div>
            <transition name="el-fade-in">
                <div class="footer" v-show="footer" :class="[isCollapsed?'footer-collapsed':'']">
                    <div class="back-btn" @click="back">返回</div>
                </div>
            </transition>
        </div>

    </div>
</template>

<script>
import assetInfo from '@/pages/info/assetInfo/list.vue'
import EmplpymentDetail from '@/components/EmplpymentDetail.vue'
export default {
    name: 'info',
    components: {
        EmplpymentDetail,assetInfo
    },
    props: {
        pageActive: {
        type: String,
        required: false, // 可选
        default: '0'     // 默认值
        }
    },
    computed: { 
        isCollapsed() {
            return this.$store.state.isCollapsed
        }
    },
    data() {
        return {
            activeName: '1',
            tags: [
                {
                    label: '个人信息',
                    name: '1'
                },
                {
                    label: '资产信息',
                    name: '2'
                },
            ],
            detail: {},
            footer:false
            
            
        }
    },
    created() {
        this.getDetail()
        setTimeout(()=>{
             this.footer = true
        },500)
    },
    watch: {
      pageActive(newValue, oldValue) {
        if (this.pageActive != newValue) {
            this.pageActive = newValue
            console.log('info>>',this.pageActive)
         }
      }
    },
    mounted() {

    },
    methods: {
         
        back() {
            this.$router.go(-1)
        },
        getDetail() {
            this.axios.get('/oa/sys/user').then((res) => {
                console.log(res)
                if (res.code == 0) {
                    this.detail = res.data || {}

                } else {
                    this.$message.error(res.message)
                }
            })
        },
        is_null(content) {
            if (content) {
                return false
            } else {
                return true
            }
        },

    }
}
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;

    .content {
        width: 100%;
        min-height: calc(100vh - 202px);
        margin-top: 16px;
        background-color: white;
        padding-left: 16px;
        padding-right: 16px;
        box-sizing: border-box;
        border-radius: 8px 8px 0 0;
        .main{
            overflow-y: visible;
            // height: calc(100vh - 266px);
            padding-right: 16px;
            // padding-right: 150px;
            .main-content-wrap{
                height: 100%;
            }
        }
        // .main {
        //     position: relative;
        //     // padding-top: 24px;
        //     // height: 100%;
        //     box-sizing: border-box;
        //     // padding-left: 16px;
        //     // padding-right: 16px;

        //     .split-line {
        //         width: 100%;
        //         height: 1px;
        //         background: #EDF2F2;
        //         border-radius: 0px 0px 0px 0px;
        //         margin-top: 14px;
        //         padding-left: 16px;
        //         padding-right: 16px;
        //         box-sizing: border-box;
        //     }

        //     .title {
        //         font-family: PingFang SC, PingFang SC;
        //         font-weight: bold;
        //         font-size: 16px;
        //         color: #2F3030;
        //         margin-top: 32px;
        //     }

        //     .content-h {
        //         width: 100%;
        //         height: 124px;
        //         background: #F8FAFA;
        //         border-radius: 4px 4px 4px 4px;
        //         margin-top: 24px;
        //         display: flex;
        //         justify-content: space-between;
        //         align-items: center;
        //         padding: 20px 16px;
        //         box-sizing: border-box;

        //         .content-h-l {

        //             display: flex;
        //             justify-content: space-between;
        //             align-items: center;

        //             .content-h-l-c {
        //                 margin-left: 12px;

        //                 .name {
        //                     font-family: PingFang SC, PingFang SC;
        //                     font-weight: bold;
        //                     font-size: 20px;
        //                     color: #2F3030;
        //                     line-height: 28px;
        //                     text-align: left;
        //                 }

        //                 .sex-m {
        //                     width: 20px;
        //                     height: 20px;
        //                     background: #E4F7F4;
        //                     border-radius: 2px 2px 2px 2px;
        //                     text-align: center;
        //                     color: rgba(45, 93, 207, 1);
        //                     margin-top: 4px;
        //                     margin-left: 6px;
        //                 }

        //                 .sex-w {
        //                     width: 20px;
        //                     height: 20px;
        //                     border-radius: 2px 2px 2px 2px;
        //                     text-align: center;
        //                     background: #FFE8EC;
        //                     margin-top: 4px;
        //                     margin-left: 6px;
        //                     color: rgba(226, 60, 88, 1)
        //                 }

        //                 .status {
        //                     width: 54px;
        //                     height: 24px;
        //                     background: #E4F7F4;
        //                     border-radius: 2px 2px 2px 2px;
        //                     font-family: PingFang SC, PingFang SC;
        //                     font-weight: 400;
        //                     font-size: 14px;
        //                     color: #00B498;
        //                     line-height: 24px;
        //                     text-align: center;
        //                     margin-top: 2px;
        //                     margin-left: 22px
        //                 }

        //                 .status1 {
        //                     width: 54px;
        //                     height: 24px;
        //                     background: #FAF5E1;
        //                     border-radius: 2px 2px 2px 2px;
        //                     font-family: PingFang SC, PingFang SC;
        //                     font-weight: 400;
        //                     font-size: 14px;
        //                     color: #F5C401;
        //                     line-height: 24px;
        //                     text-align: center;
        //                     margin-top: 2px;
        //                     margin-left: 22px
        //                 }

        //                 .status2 {
        //                     width: 54px;
        //                     height: 24px;
        //                     background: #E8EEFA;
        //                     border-radius: 2px 2px 2px 2px;
        //                     font-family: PingFang SC, PingFang SC;
        //                     font-weight: 400;
        //                     font-size: 14px;
        //                     color: #2D5DCF;
        //                     line-height: 24px;
        //                     text-align: center;
        //                     margin-top: 2px;
        //                     margin-left: 22px
        //                 }

        //                 .text {
        //                     font-family: PingFang SC, PingFang SC;
        //                     font-weight: 400;
        //                     font-size: 14px;
        //                     color: #2F3030;
        //                     margin-right: 40px;
        //                 }
        //             }
        //         }

        //         .content-h-r {
        //             .time {
        //                 font-family: PingFang SC, PingFang SC;
        //                 font-weight: 400;
        //                 font-size: 14px;
        //                 color: #939696;
        //                 line-height: 0px;
        //                 text-align: right;
        //                 margin-top: -30px;
        //             }
        //         }
        //     }

        //     .content-c {
        //         margin-top: 30px;
        //         // padding-left: 16px;
        //         // padding-right: 16px;
        //         // box-sizing: border-box;

        //         .l-form {
        //             .el-form-item {
        //                 // width: 290px;
        //                 width: 20%;
        //                 margin-right: 0px !important;
        //             }

        //             /deep/.el-form-item__label {
        //                 color: #939696;
        //             }
        //         }

        //         .l-form1 {
        //             .el-form-item {
        //                 // width: 290px;
        //                 width: 25%;
        //                 margin-right: 0px !important;
        //             }

        //             /deep/.el-form-item__label {
        //                 color: #939696;
        //             }
        //         }

        //         .text-f {
        //             font-family: PingFang SC, PingFang SC;
        //             font-weight: 400;
        //             font-size: 14px;
        //             color: #2F3030;
        //             line-height: 32px;
        //         }

        //         .relative {
        //             width: 100%;
        //             min-height: 52px;
        //             padding: 10px 0 0 0;
        //             box-sizing: border-box;
        //             background: #F8FAFA;
        //             border-radius: 0px 0px 0px 0px;
        //             display: flex;
        //             justify-content: flex-start;
        //             align-items: center;
        //         }

        //         .sort-index {
        //             width: 16px;
        //             height: 16px;
        //             background: #E4F7F4;
        //             line-height: 16px;
        //             border-radius: 50%;
        //             font-family: PingFang SC, PingFang SC;
        //             font-weight: bold;
        //             font-size: 12px;
        //             color: #00B498;
        //             text-align: center;
        //         }

        //         .sort-title {
        //             font-family: PingFang SC, PingFang SC;
        //             font-weight: bold;
        //             font-size: 14px;
        //             color: #2F3030;
        //             margin-left: 2px;
        //         }
        //     }

        //     .main-content {
        //         margin-top: 30px;

        //     }


        // }

         .footer {
            height: 84px;
            background: #FFFFFF;
            display: flex;
            justify-content: center;
            align-items: center;
            position: fixed;
            left: 200px;
            right: 0;
            bottom: 0;
            border-top: 1px solid #EDF2F2;
            box-sizing: border-box;
            transition: left 0.3s ease-in-out ;
            z-index: 2;
            .back-btn {
                width: 88px;
                height: 36px;
                background: #EDF2F2;
                border-radius: 4px 4px 4px 4px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #939696;
                line-height: 36px;
                text-align: center;
                // margin-left: 24px;
                cursor: pointer;

            }
        }
        .footer-collapsed{
            left: 80px;
        }
    }

}
</style>
